import {getModuleSpecs} from './get-modules-specs';
import {isJquery} from './is-jquery';
import {ELEMENTS_HAVING_DATA_JSOBJ_INCLUDING_LATE_INIT} from './selectors';
import {detachModulesFromEl} from './detach-modules-from-el';

export function destroy(element) {
    if (!element) {
        // it may happen in some unclear situations
        return;
    }

    if (isJquery(element)) {
        element.each((i, el) => destroy(el));
        return;
    }

    const childrenWithModuleSpecs = Array.from(
        element.querySelectorAll(ELEMENTS_HAVING_DATA_JSOBJ_INCLUDING_LATE_INIT),
    );

    const elementsWithModuleSpecs = getModuleSpecs(element) ? [element, ...childrenWithModuleSpecs] : childrenWithModuleSpecs;

    elementsWithModuleSpecs.forEach((el) => (
        detachModulesFromEl(el)
    ));
}
